import { render } from "./maintenancePage.vue?vue&type=template&id=df85ca56&scoped=true&ts=true"
import script from "./maintenancePage.vue?vue&type=script&lang=ts"
export * from "./maintenancePage.vue?vue&type=script&lang=ts"

import "./maintenancePage.vue?vue&type=style&index=0&id=df85ca56&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-df85ca56"]])

export default __exports__